import { Component, EventEmitter, Input, Output } from "@angular/core";

@Component({
  selector: "field-set-style",
  templateUrl: "./field-set-style.component.html",
  styles: [],
})
export class FieldSetStyleComponent {

  @Input() public fieldOptions: any;
  @Output() public dataChanged = new EventEmitter();
  public styles: string[] = ["alert alert-success", "alert alert-info", "alert alert-warning", "alert alert-danger"];

  public dataChangedEvent(event) {
    this.dataChanged.emit(event);
  }

}
